import { createFileRoute } from "@tanstack/react-router";
import { EsLegalPage, EsLegalSection } from "@/components/site/EsPage";
import { buildHead } from "@/lib/seo-head";

export const Route = createFileRoute("/es/legal/divulgaciones")({
  head: () =>
    buildHead({
      title: "Avisos Legales — Simply Approved Mortgages",
      description:
        "Descargos de responsabilidad sobre tasas, datos de fuentes de terceros, simulaciones de calculadoras y contenido educativo.",
      url: "/es/legal/divulgaciones",
      locale: "es",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Divulgaciones", url: "/es/legal/divulgaciones" },
      ],
    }),
  component: Page,
});

function Page() {
  return (
    <EsLegalPage
      title="Avisos legales"
      intro="Descargos importantes sobre las cifras, tasas, calculadoras y fuentes de datos que aparecen en este sitio."
      enPath="/legal/disclaimers"
      enLabel="Disclaimers"
    >
      <EsLegalSection heading="Tasas y términos">
        <p>
          Las tasas, pagos, puntos, comisiones y términos mostrados son ilustrativos y provienen de
          cotizaciones de prestamistas mayoristas. No constituyen una oferta de crédito ni un
          compromiso de financiamiento. Los términos reales dependen de la aprobación del
          prestamista, el crédito, la propiedad, la suscripción y otros factores.
        </p>
      </EsLegalSection>

      <EsLegalSection heading="Calculadoras">
        <p>
          Nuestras calculadoras generan estimaciones con fines informativos únicamente. No reemplazan
          una cotización formal, un CDF (Closing Disclosure) ni una aprobación de préstamo. Los
          impuestos, seguros, HOA y otros costos reales pueden variar.
        </p>
      </EsLegalSection>

      <EsLegalSection heading="Fuentes de datos">
        <p>
          Algunos datos provienen de fuentes públicas y de terceros (HUD, Census, FRED, BLS, FHFA,
          etc.). Hacemos esfuerzos razonables para mantenerlos actualizados, pero no garantizamos su
          exactitud ni vigencia. Verifique siempre con la fuente oficial antes de actuar.
        </p>
      </EsLegalSection>

      <EsLegalSection heading="Afiliación gubernamental">
        <p>
          Simply Approved Mortgages LLC no es una agencia gubernamental ni está afiliada con HUD,
          FHA, VA, USDA ni ninguna entidad federal o estatal. Cuando describimos programas
          gubernamentales, lo hacemos con fines educativos.
        </p>
      </EsLegalSection>
    </EsLegalPage>
  );
}
